module.exports = __webpack_public_path__ + "static/media/tapleyjung1.f1988292.ogg";